import { Api } from "@vzbl/integrations";
import { unitTypeForCol } from "src/utils/strings";

export const valueFromRecord = (
  record: Record<string, Api.FieldValue>,
  key: string,
  columnInfo?: Api.Schema.ColumnInfo
): { value: string; delta?: string; percent?: string } => {
  const value = record[key];
  if (columnInfo && unitTypeForCol(key, columnInfo).tuple) {
    const [a = "0", b = "0"] = `${value}`.split(",").slice(-2);
    const aN = a === "__VZBL::null__" ? 0 : Number(a);
    const bN = b === "__VZBL::null__" ? 0 : Number(b);
    const delta = bN - aN;
    // on divide-by-zero, we'll choose 0 or 100 depending on the value of B
    const percent = Math.round(
      aN === 0 ? (bN === 0 ? 0 : 100) : (delta / aN) * 100
    );
    return {
      value: `${bN}`, // 0 instead of undefined or __VZBL::null__
      delta: `${delta}`,
      percent: `${percent}`,
    };
  }
  if (
    typeof value == "object" &&
    !Array.isArray(value) &&
    value != null &&
    "value" in value
  ) {
    return { value: `${value.value}` };
  }
  return { value: `${value}` };
};

export function valueToNumber(value: string | number): string {
  if (
    value === "__VZBL::null__" ||
    value === "null" ||
    value === null ||
    !value
  )
    return "0";
  return /\d\.\d\d\d+/.test(`${value}`)
    ? Number.parseFloat(`${value}`).toFixed(2)
    : `${value}`;
}

export function valueToLabel(value: string | { label: string }): string {
  if (typeof value === "object") return value.label;
  if (value === "__VZBL::null__") return "n/a";
  return `${value}`;
}
